import { Input, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@quadminds/mindkit';
import { MindyRolesPermissions, MindyStandardRoles } from '@quadminds/mindy-shared';
import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';
import { ArrowUpDown, Search } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useByPassContext } from '../../../../providers/ByPass/ByPass.provider';
import FrameLayout from '../FrameLayout/FrameLayout';
import Permissions from '../Permissions/Permissions';
import UserActions from '../UserActions/UserActions';

const DefaultUserRoles: Record<MindyStandardRoles, string> = {
    [MindyStandardRoles.ADMIN]: 'administrator',
    [MindyStandardRoles.MANAGER]: 'manager',
    [MindyStandardRoles.GUEST]: 'guest',
    [MindyStandardRoles.CONSULTANT]: 'consultant',
    [MindyStandardRoles.OPERATIONAL]: 'operational',
};

export function Roles() {
    const { t } = useTranslation();
    const [showConfig, setShowConfig] = useState('');
    const queryClient = useQueryClient(); // Access the query client
    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']); // Retrieve userInfo from the cache
    const currentUserPermissions = userInfo?.permissions || [];
    const { isImpersonated } = useByPassContext();

    const showActions = currentUserPermissions.includes(MindyRolesPermissions.UpdateRole) || isImpersonated;
    // const [selectedRoles, setSelectedRoles] = useState<MindyStandardRoles[]>([]);

    // const handleSelectAll = (checked: boolean) => {
    //     if (checked) {
    //         setSelectedRoles(roles.map((role) => role.id));
    //     } else {
    //         setSelectedRoles([]);
    //     }
    // };

    // const handleSelectRole = (userId: string, checked: boolean) => {
    //     if (checked) {
    //         setSelectedRoles([...selectedRoles, userId]);
    //     } else {
    //         setSelectedRoles(selectedRoles.filter((id: string) => id !== userId));
    //     }
    // };

    // const isAllSelected = selectedRoles.length === roles.length;
    // const isIndeterminate = selectedRoles.length > 0 && selectedRoles.length < roles.length;

    return (
        <FrameLayout title="Roles y Permisos">
            <div className={`border rounded-lg shadow-sm `}>
                <div className="p-4 border-b flex flex-col gap-4">
                    <div className="flex flex-col flex-wrap lg:flex-row gap-2 justify-between ">
                        <div className="flex items-center gap-2">
                            <div className="relative flex-1 lg:max-w-80 min-w-48">
                                <Search className="absolute left-2.5 top-3 h-4 w-4 text-muted-foreground" />
                                <Input
                                    type="search"
                                    placeholder={'Buscar Rol'}
                                    className="pl-8"
                                    onChange={() => {
                                        return;
                                    }}
                                    data-testid="search-input"
                                />
                            </div>
                        </div>
                        {/* <Button className="">
                            <span>Crear Rol</span>
                        </Button> */}
                    </div>
                </div>
                <div>
                    <Table>
                        <TableHeader>
                            <TableRow className="border-gray-700 hover:bg-gray-800/50">
                                {/* <TableHead className="w-12">
                                    <Checkbox
                                        checked={isAllSelected}
                                        onCheckedChange={handleSelectAll}
                                        aria-label="Select all users"
                                        {...(isIndeterminate && { 'data-state': 'indeterminate' })}
                                    />
                                </TableHead> */}
                                <TableHead className="text-gray-300 font-medium w-full">
                                    <div className="flex items-center gap-2">
                                        Nombre
                                        <ArrowUpDown className="h-4 w-4" />
                                    </div>
                                </TableHead>
                                {/* <TableHead className="text-gray-300 font-medium">
                                    <div className="flex items-center gap-2">
                                        Miembros
                                        <ArrowUpDown className="h-4 w-4" />
                                    </div>
                                </TableHead>
                                <TableHead className="text-gray-300 font-medium">
                                    <div className="flex items-center gap-2">
                                        Última modificación
                                        <ArrowUpDown className="h-4 w-4" />
                                    </div>
                                </TableHead> */}
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {Object.keys(DefaultUserRoles).map((role) => (
                                <TableRow key={role} className="border-gray-700 hover:bg-gray-800/50">
                                    {/* <TableCell>
                                        <Checkbox
                                            checked={selectedRoles.includes(role)}
                                            onCheckedChange={(checked) => handleSelectRole(role, checked as boolean)}
                                            aria-label={`Select ${t(`setting.roles.${DefaultUserRoles[role as MindyStandardRoles]}`)}`}
                                        />
                                    </TableCell> */}
                                    <TableCell>
                                        <div className="flex items-center gap-3 w-full">
                                            <div>
                                                <div className="font-medium text-white">
                                                    {t(
                                                        `settings.roles.${
                                                            DefaultUserRoles[role as MindyStandardRoles]
                                                        }`,
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </TableCell>
                                    {/* <TableCell className="font-medium text-white">{role.members}</TableCell>
                                    <TableCell>
                                        <div>
                                            <div className="font-medium text-white">{role.lastModifiedBy}</div>
                                            <div className="text-sm text-gray-400">{role.lastModifiedDate}</div>
                                        </div>
                                    </TableCell> */}
                                    {showActions && (
                                        <TableCell>
                                            <UserActions
                                                user={role}
                                                onDelete={() => null}
                                                onOpenSettings={() => setShowConfig(role)}
                                                disableDelete={true}
                                            />
                                            {showConfig === role && (
                                                <Permissions
                                                    id={role as MindyStandardRoles}
                                                    handleClose={() => setShowConfig('')}
                                                    isOpen={showConfig === role}
                                                />
                                            )}
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </FrameLayout>
    );
}

export default Roles;
